// import { Formik } from 'formik';
import React from 'react';
// import './styles/components.scss';

const RadioButton = ({
  field: { name, value, onChange, onBlur, onClick },
  id,
  label,
  className,
  checked,
  config,
  formik,
  ...props
}) => {
  
  return (
    <span className='radio-option radio-item' style={{width:'20%', display: 'inline'}}>
      <input
        name={name}
        id={id}
        type="radio"
        value={value} 
        checked={(name !== 'deliveryMethodGroup') ? value === id : formik.values.releasemodePdf === id}
        onChange={onChange}
        onBlur={onBlur}
        onClick={onClick}
        className="radio-button" 
        // className=''
        {...props}
      />
      <label style={{...config.page.form.styles.list}}  htmlFor={id}>{label}</label>
    </span>
  );
};

export default RadioButton;